import styled from 'styled-components';
import { prem } from 'styles/helpers/spacing';

const TrimaProgressHeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${prem(8)};
  padding: ${prem(12)} ${prem(16)} ${prem(4)};

  .trima-step-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: ${prem(12)};
    color: var(--ion-text-color-secondary);
  }

  .trima-step-global {
    font-weight: 500;
  }

  .trima-step-local {
    font-weight: 400;
  }

  .trima-progress-bar {
    width: 100%;
    height: ${prem(4)};
    background: var(--ion-color-light, #e5e5e5);
    border-radius: ${prem(2)};
    overflow: hidden;
  }

  .trima-progress-bar-fill {
    height: 100%;
    background: var(--ion-color-primary);
    transition: width 0.3s ease;
    border-radius: ${prem(2)};
  }
`;

export { TrimaProgressHeaderWrapper };
